import { Link } from "@tanstack/react-router";
import { Crown, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { gateCopy, type GateReason } from "@/lib/plan-gates";
import { cn } from "@/lib/utils";

interface UpgradePromptProps {
  readonly reason: GateReason;
  /** inline: faixa compacta junto do controle bloqueado; card: bloco da tela. */
  readonly variant?: "inline" | "card";
  readonly className?: string;
}

/** Upsell contextual exibido quando um gate de plano bloqueia uma acao. */
export function UpgradePrompt({ reason, variant = "card", className }: UpgradePromptProps): JSX.Element {
  const copy = gateCopy(reason);
  const isInline = variant === "inline";

  return (
    <div
      role="note"
      aria-label={copy.title}
      className={cn(
        "rounded-xl border border-gold/30 bg-gold/5",
        isInline ? "flex flex-col gap-3 p-3 sm:flex-row sm:items-center" : "space-y-4 p-6 text-center",
        className,
      )}
    >
      <div className={cn("flex gap-3", isInline ? "min-w-0 flex-1 items-start" : "flex-col items-center")}>
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gold/15 text-gold">
          <Lock size={16} aria-hidden="true" />
        </span>
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-semibold text-foreground">{copy.title}</p>
          <p className="text-xs text-muted-foreground">{copy.description}</p>
        </div>
      </div>
      <Button asChild variant="gold" size={isInline ? "sm" : "default"} className="shrink-0">
        <Link to="/app/plans">
          <Crown size={14} aria-hidden="true" />
          Conhecer o {copy.requiredLabel}
        </Link>
      </Button>
    </div>
  );
}
